export default "__VITE_ASSET__47c724bb__"